






































































import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Component } from '@niknevis/vue-modules'
import Confirm from '@/modules/common/dialog/components/shared/Confirm.vue'
import Vue from 'vue'
import {
  ContentCampaignCompletedUseCase
} from '@/modules/content-campaign/use-cases/admin/content-campaign-completed.use-case'
import { ContentCampaignCompletedRequestModel } from '@/modules/content-campaign/models/content-campaign-request.model'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'

@Component({
  components: {
    BaseButton,
    Confirm,
    Toggle
  }
})
export default class AdminContentCampaignCompleteButton extends Vue {
  constructor(
    protected readonly makeCompletedUC: ContentCampaignCompletedUseCase
  ) {
    super()
  }

  @Prop() completed_at?: string
  @Prop({ required: true }) id!: number
  @Prop({ default: 'تکمیل کردن' }) label?: string

  showDialog = false

  requestData: ContentCampaignCompletedRequestModel = {
    save_profit: !!!this.completed_at
  }

  sendRequest() {
    this.makeCompletedUC.execute(this.id, this.requestData)
      .then(() => {
        this.showDialog = false
      })
  }
}
